import axios from "axios";

const API = process.env.REACT_APP_API_GO;

export const getLookupsPhytosanitaryProgram = async (filters) => {
	const { data } = await axios.get(`${API}/app/planning/phytosanitary_program/lookups`, { params: filters });
	return data;
};

export const getPhytosanitaryProgram = async (filters) => {
	const { data } = await axios.get(`${API}/app/planning/phytosanitary_program`, { params: filters });
	return data;
};

export const importExcelPhytosanitaryProgram = async (formData) => {
	const { data } = await axios.post(`${API}/app/planning/phytosanitary_program/import`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return data;
};

export const validatePhytosanitaryProgramName = async (file) => {
	const formData = new FormData();
	formData.append("file", file);

	const { data } = await axios.post(`${API}/app/planning/phytosanitary_program/validate`, formData, {
		headers: {
			"Content-Type": "multipart/form-data",
		},
	});
	return data;
};

export const savePhytosanitaryProgram = async (form) => {
	const { data } = await axios.post(`${API}/app/planning/phytosanitary_program/save`, form);
	return data;
};

export const createApplicationOrderFromProgram = async (form) => {
	const { data } = await axios.post(`${API}/app/planning/order_application/create_from_program`, form);
	return data;
};

export const getPhytosanitaryProgramProgress = async (filters) => {
	const { data } = await axios.get(`${API}/app/planning/phytosanitary_program/progress`, { params: filters });
	return data;
};

export const deletePhytosanitaryProgram = async (programId) => {
	const { data } = await axios.delete(`${API}/app/planning/phytosanitary_program`, {
		data: { program_id: programId },
	});
	return data;
};

export const deletePhytosanitaryProgramApplication = async ({ programId, applicationNumber, filters }) => {
	const { data } = await axios.delete(`${API}/app/planning/phytosanitary_program/application`, {
		data: { program_id: programId, application_number: applicationNumber, filters },
	});
	return data;
};

export const addPhytosanitaryProgramRows = async (form) => {
	const { data } = await axios.post(`${API}/app/planning/phytosanitary_program/add_rows`, form);
	return data;
};
